import {getNavigator} from 'util/utils';

const LANG_INIT = 0;
const LANG_LENGHT = 2;
const ENGLISH_CODE = 'en';
const SPANISH_CODE = 'es';

const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';

export const changeLanguage = code => ({type: LANGUAGE_CHANGE, code});

/**
 * If the browser language is spanish, it will set the default languages in Spanish.
 * If the browser languages is any else, it will set the default langues in English
 * @returns {string} the code with the default langues ('es' or 'en)
 * @private
 */
const _setDefaultLanguage = () => {
    const lang = ENGLISH_CODE;
    const browserLanguage = getNavigator().language.substring(LANG_INIT, LANG_LENGHT);

    if (browserLanguage === SPANISH_CODE) {
        return SPANISH_CODE;
    }

    return lang;

};

// Reducer
const _defaultState = () => ({
    lang: _setDefaultLanguage()
});


export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case LANGUAGE_CHANGE:
        return {
            ...state,
            lang: action.code
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/language.js